import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppConfig } from "../../../AppConfig";
import { PageRoutes } from "../../../constants/routes";
import { AuthTokenLoginResponse } from "../../../core/api/requests/auth/token_login/types";
import { CookieManager } from "../../../core/storage/CookieManager";
import { LocalStorageManager } from "../../../core/storage/LocalStorageManager";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { dataSelectors } from "../../../ducks/data";
import { AppDispatch } from "../../../store";
import { isNowInDateRange } from "../../../utils/date";

export const useAuthTemplate = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigation = useNavigate();
  const maintenance = useSelector(dataSelectors.maintenance);

  useEffect(() => {
    const accessToken = LocalStorageManager.Instance.getObject<string>(
      AppConfig.Instance.LocalStorageKey["accessToken"],
    );
    dispatch(authActions.setIsLoggedIn(!!accessToken));
    //
    if (accessToken) {
      // save token to cookie
      CookieManager.Instance.saveObject(
        AppConfig.Instance.CookieKey["accessToken"],
        accessToken,
        process.env.REACT_APP_COMMON_DOMAIN,
      );
      dispatch(authActions.getLoggedInUser.started({}));
    } else {
      // get cookie
      const cookieAccessToken = CookieManager.Instance.getObject<string>(
        AppConfig.Instance.CookieKey["accessToken"],
      );
      //
      if (cookieAccessToken) {
        // get token
        dispatch(appActions.showLoading());
        dispatch(
          authActions.tokenLogin.started({
            access_token: cookieAccessToken,
            onComplete: () => {
              dispatch(appActions.hideLoading());
            },
            onSuccess: (data: AuthTokenLoginResponse) => {
              LocalStorageManager.Instance.saveObject(
                AppConfig.Instance.LocalStorageKey["accessToken"],
                data.access_token,
              );
              CookieManager.Instance.saveObject(
                AppConfig.Instance.CookieKey["accessToken"],
                data.access_token,
                process.env.REACT_APP_COMMON_DOMAIN,
              );
              dispatch(authActions.setIsLoggedIn(!!data.access_token));
              dispatch(authActions.getLoggedInUser.started({}));
            },
            onError: () => {
              CookieManager.Instance.removeObject(
                AppConfig.Instance.CookieKey["accessToken"],
                process.env.REACT_APP_COMMON_DOMAIN,
              );
              LocalStorageManager.Instance.removeObject(
                AppConfig.Instance.LocalStorageKey["accessToken"],
              );
              dispatch(authActions.setIsLoggedIn(false));
            },
          }),
        );
      }
    }
  }, []);

  useEffect(() => {
    if (
      maintenance.start_date &&
      maintenance.end_date &&
      maintenance.is_maintenance &&
      isNowInDateRange(maintenance.start_date, maintenance.end_date)
    ) {
      navigation(PageRoutes.MAINTENANCE);
    }
  }, [maintenance]);

  return {};
};
